import { mutator } from 'satcheljs';
import getStore from '../store/store';
import selectForwardMeetingNotificationOption from '../../actions/selectForwardMeetingNotificationOption';
/**
 * Called when there is a change in the forward meeting notification option
 */
export default mutator(selectForwardMeetingNotificationOption, function (actionMessage) {
    var optionState = getStore();
    optionState.removeForwardedMeetingNotifications =
        actionMessage.removeForwardedMeetingNotifications;
});
//# sourceMappingURL=selectForwardMeetingNotificationOption.js.map